/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_Almost_OverdueInputs */

const vi_sla_almost_overdue = /** @type {(inputs: Sla_Almost_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp trễ`)
};

/**

* @param {Sla_Almost_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_almost_overdue = /** @type {((inputs?: Sla_Almost_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_Almost_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_almost_overdue(inputs)
});